import React, { useEffect, useState } from "react";
import { PickerView } from "antd-mobile";

type Props = {
  className?: string;
  value?: Date | string;
  onChange?: (value: string)=> void;
}

const SecondsPickerView: React.FC<Props> = (props)=> {

  const [value, setValue] = useState(['00'])

  const [data] = useState(()=> {
    const list = []
    for(let i=0; i<60; i++) {
      const fill = i > 9 ? `${i}` : `0${i}`;
      list.push({
        label: `${fill}秒`,
        value: fill
      })
    }
    return list
  })

  useEffect(()=> {
    // console.log('?d', props.value)
    if(props.value instanceof Date) {
      const second = props.value.getSeconds()
      setValue([second > 9 ? `${second}` : `0${second}`])
    } else if (typeof props.value === 'string') {
      const mat = /^\d{4}-\d{2}-\d{2}(T| )\d{2}:\d{2}:\d{2}(\.\d{3}Z)?$/.exec(props.value)
      if(mat) {
        setValue([mat[2]])
      }
    }
  }, [props.value])

  const changeControl = (value: string[])=> {
    props.onChange && props.onChange(value[0])
  }

  return <PickerView
    data={data}
    value={value}
    cascade={false}
    cols={1}
    onChange={changeControl}
    prefixCls={props.className}
  />
}

export default SecondsPickerView